import axios from 'axios';
import { useEffect, useRef } from 'react';

const INTERVAL_TIME = 30 * 60 * 1000;

const events = [
    'mousedown',
    'mousemove',
    'wheel',
    'keydown',
    'touchstart',
    'scroll',
    // ... add other events here ...
];

const useRefreshTokenInterval = ({ auth, interval = INTERVAL_TIME, onRefreshFailed, onRefreshed }) => {
    const intervalRef = useRef(null);
    const inFlightRef = useRef(false);

    useEffect(() => {
        if (!auth?.course_id) return;

        const refreshToken = async () => {
            if (inFlightRef.current) return;

            const refreshTokenValue = localStorage.getItem('refresh_token');
            if (!refreshTokenValue) return;

            inFlightRef.current = true;
            try {
                const resp = await axios.post('/get-refresh-token', {
                    code: refreshTokenValue,
                    course_id: auth.course_id,
                });

                const data = resp;

                if (!data?.access_token) throw new Error('Missing access_token from refresh response');

                localStorage.setItem('access_token', data.access_token);

                // D2L rotating refresh token: always store the new one if present
                if (data.refresh_token) {
                    localStorage.setItem('refresh_token', data.refresh_token);
                }

                onRefreshed?.(data);
            } catch (e) {
                onRefreshFailed?.(e);
            } finally {
                inFlightRef.current = false;
            }
        };

        // optional: do one immediately so you don't wait 4 minutes
        refreshToken();

        intervalRef.current = setInterval(refreshToken, interval);

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [auth?.course_id, interval, onRefreshFailed, onRefreshed]);
};

export default useRefreshTokenInterval;
